import { render, staticRenderFns } from "./EditVehicleMake.vue?vue&type=template&id=0e83879e"
import script from "./EditVehicleMake.vue?vue&type=script&lang=ts"
export * from "./EditVehicleMake.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports